module.exports = __webpack_public_path__ + "img/25-50.c66dacdb.png";